import cloneDeep from 'lodash/cloneDeep'

const addNewPoint = (currentPointList, data) => {
  const cloneCurrentPointList = cloneDeep(currentPointList)
  const cloneData = cloneDeep(data)
  cloneCurrentPointList.push(cloneData)
  return cloneCurrentPointList
}

export default addNewPoint
